<template>
    <div id="stepcontent">
        <div id="title">
            <h2>Dados profissionais</h2>
            <p>Preencha com os dados profissionais</p>
        </div>

        <div id="formblock">

            <div>

                <div class="sectiontitle" style="margin-top: 1rem;">
                    <hr><h3> Dados 1º proponente</h3><hr>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.proponente_1.actividade_profissional)}" class="input-line cursor-pointer" @click="ddopen !== 'actividade_profissional_proponente_1' ? ddopen = 'actividade_profissional_proponente_1': ddopen = null">
                        <div class="input-title">
                            <p>Actividade Profissional*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.proponente_1.actividade_profissional" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'actividade_profissional_proponente_1', 'unflip': ddopen !== 'actividade_profissional_proponente_1'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'actividade_profissional_proponente_1'" class="input-expanded">
                            <p v-for="i in actividades_profissionais" class="expanded-line" @click="stepdata.proponente_1.actividade_profissional = i; ddopen = null;">{{i}}</p>
                        </div>
                    </transition>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_1.profissao)}" class="input-line">
                    <div class="input-title">
                        <p>Profissão*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_1.profissao" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.proponente_1.tipo_contrato)}" class="input-line cursor-pointer" @click="ddopen !== 'tipo_contrato_proponente_1' ? ddopen = 'tipo_contrato_proponente_1': ddopen = null">
                        <div class="input-title">
                            <p>Tipo de Contrato*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.proponente_1.tipo_contrato" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'tipo_contrato_proponente_1', 'unflip': ddopen !== 'tipo_contrato_proponente_1'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'tipo_contrato_proponente_1'" class="input-expanded">
                            <p v-for="i in tipos_contrato" class="expanded-line" @click="stepdata.proponente_1.tipo_contrato = i; ddopen = null;">{{i}}</p>
                        </div>
                    </transition>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.proponente_1.antiguidade)}" class="input-line">
                        <div class="input-title">
                            <p>Antiguidade no sector (anos)*</p>
                        </div>

                        <div class="input-field">
                            <input v-mask="'##'" v-model="stepdata.proponente_1.antiguidade" type="text">
                        </div>

                        <div class="input-icon">
                        </div>

                    </div>

                </div>

                <div :class="{'badinput': bad(stepdata.proponente_1.vencimento_mensal)}" class="input-line">
                    <div class="input-title">
                        <p>Vencimento Mensal Líquido*</p>
                    </div>

                    <div class="input-field">
                        <money v-model="stepdata.proponente_1.vencimento_mensal" v-bind="money"></money>
                    </div>

                    <div class="input-icon">
                        €
                    </div>
                </div>

                <div class="input-line">
                    <div class="input-title">
                        <p>Outros Rendimentos Mensais</p>
                    </div>

                    <div class="input-field">
                        <money v-model="stepdata.proponente_1.outros_rendimentos" v-bind="money"></money>
                    </div>

                    <div class="input-icon">
                        €
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_1.nome_empresa) && !pensionistaOuOutro(stepdata.proponente_1)}" class="input-line">
                    <div class="input-title">
                        <p>Nome da Empresa*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_1.nome_empresa" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_1.data_entrada) && !pensionistaOuOutro(stepdata.proponente_1)}" class="input-line">
                    <div class="input-title">
                        <p>Data de Entrada na Empresa</p>
                    </div>

                    <div class="input-field">
                        <input v-mask="'##/##/####'" @blur="stepdata.proponente_1.data_entrada = fixData(stepdata.proponente_1.data_entrada)" v-model="stepdata.proponente_1.data_entrada" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

            </div>

            <div v-if="numProponentes == 2">

                <div class="sectiontitle">
                    <hr><h3> Dados 2º proponente</h3><hr>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.proponente_2.actividade_profissional)}" class="input-line cursor-pointer" @click="ddopen !== 'actividade_profissional_proponente_2' ? ddopen = 'actividade_profissional_proponente_2': ddopen = null">
                        <div class="input-title">
                            <p>Actividade Profissional*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.proponente_2.actividade_profissional" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'actividade_profissional_proponente_2', 'unflip': ddopen !== 'actividade_profissional_proponente_2'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'actividade_profissional_proponente_2'" class="input-expanded">
                            <p v-for="i in actividades_profissionais" class="expanded-line" @click="stepdata.proponente_2.actividade_profissional = i; ddopen = null;">{{i}}</p>
                        </div>
                    </transition>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_2.profissao)}" class="input-line">
                    <div class="input-title">
                        <p>Profissão*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_2.profissao" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.proponente_2.tipo_contrato)}" class="input-line cursor-pointer" @click="ddopen !== 'tipo_contrato_proponente_2' ? ddopen = 'tipo_contrato_proponente_2': ddopen = null">
                        <div class="input-title">
                            <p>Tipo de Contrato*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.proponente_2.tipo_contrato" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'tipo_contrato_proponente_2', 'unflip': ddopen !== 'tipo_contrato_proponente_2'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'tipo_contrato_proponente_2'" class="input-expanded">
                            <p v-for="i in tipos_contrato" class="expanded-line" @click="stepdata.proponente_2.tipo_contrato = i; ddopen = null;">{{i}}</p>
                        </div>
                    </transition>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.proponente_2.antiguidade)}" class="input-line">
                        <div class="input-title">
                            <p>Antiguidade no sector (anos)*</p>
                        </div>

                        <div class="input-field">
                            <input  v-mask="'##'" v-model="stepdata.proponente_2.antiguidade" type="text">
                        </div>

                        <div class="input-icon">
                        </div>

                    </div>

                </div>

                <div :class="{'badinput': bad(stepdata.proponente_2.vencimento_mensal)}" class="input-line">
                    <div class="input-title">
                        <p>Vencimento Mensal Líquido*</p>
                    </div>

                    <div class="input-field">
                        <money v-model="stepdata.proponente_2.vencimento_mensal" v-bind="money"></money>
                    </div>

                    <div class="input-icon">
                        €
                    </div>
                </div>

                <div class="input-line">
                    <div class="input-title">
                        <p>Outros Rendimentos Mensais</p>
                    </div>

                    <div class="input-field">
                        <money v-model="stepdata.proponente_2.outros_rendimentos" v-bind="money"></money>
                    </div>

                    <div class="input-icon">
                        €
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_2.nome_empresa) && !pensionistaOuOutro(stepdata.proponente_2)}" class="input-line">
                    <div class="input-title">
                        <p>Nome da Empresa*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.proponente_2.nome_empresa" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.proponente_2.data_entrada) && !pensionistaOuOutro(stepdata.proponente_2)}" class="input-line">
                    <div class="input-title">
                        <p>Data de Entrada na Empresa</p>
                    </div>

                    <div class="input-field">
                        <input v-mask="'##/##/####'" @blur="stepdata.proponente_2.data_entrada = fixData(stepdata.proponente_2.data_entrada)" v-model="stepdata.proponente_2.data_entrada" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>


            </div>

            <div v-if="numFiadores >= 1">

                <div class="sectiontitle">
                    <hr><h3> Dados 1º fiador</h3><hr>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.fiador_1.actividade_profissional)}" class="input-line cursor-pointer" @click="ddopen !== 'actividade_profissional_fiador_1' ? ddopen = 'actividade_profissional_fiador_1': ddopen = null">
                        <div class="input-title">
                            <p>Actividade Profissional*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.fiador_1.actividade_profissional" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'actividade_profissional_fiador_1', 'unflip': ddopen !== 'actividade_profissional_fiador_1'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'actividade_profissional_fiador_1'" class="input-expanded">
                            <p v-for="i in actividades_profissionais" class="expanded-line" @click="stepdata.fiador_1.actividade_profissional = i; ddopen = null;">{{i}}</p>
                        </div>
                    </transition>
                </div>

                <div :class="{'badinput': bad(stepdata.fiador_1.profissao)}" class="input-line">
                    <div class="input-title">
                        <p>Profissão*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.fiador_1.profissao" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.fiador_1.tipo_contrato)}" class="input-line cursor-pointer" @click="ddopen !== 'tipo_contrato_fiador_1' ? ddopen = 'tipo_contrato_fiador_1': ddopen = null">
                        <div class="input-title">
                            <p>Tipo de Contrato*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.fiador_1.tipo_contrato" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'tipo_contrato_fiador_1', 'unflip': ddopen !== 'tipo_contrato_fiador_1'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'tipo_contrato_fiador_1'" class="input-expanded">
                            <p v-for="i in tipos_contrato" class="expanded-line" @click="stepdata.fiador_1.tipo_contrato = i; ddopen = null;">{{i}}</p>
                        </div>
                    </transition>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.fiador_1.antiguidade)}"  class="input-line">
                        <div class="input-title">
                            <p>Antiguidade no sector (anos)*</p>
                        </div>

                        <div class="input-field">
                            <input  v-mask="'##'" v-model="stepdata.fiador_1.antiguidade" type="text">
                        </div>

                        <div class="input-icon">
                        </div>

                    </div>

                </div>

                <div :class="{'badinput': bad(stepdata.fiador_1.vencimento_mensal)}"  class="input-line">
                    <div class="input-title">
                        <p>Vencimento Mensal Líquido*</p>
                    </div>

                    <div class="input-field">
                        <money v-model="stepdata.fiador_1.vencimento_mensal" v-bind="money"></money>
                    </div>

                    <div class="input-icon">
                        €
                    </div>
                </div>

                <div class="input-line">
                    <div class="input-title">
                        <p>Outros Rendimentos Mensais</p>
                    </div>

                    <div class="input-field">
                        <money v-model="stepdata.fiador_1.outros_rendimentos" v-bind="money"></money>
                    </div>

                    <div class="input-icon">
                        €
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.fiador_1.nome_empresa)} && !pensionistaOuOutro(stepdata.fiador_1)"  class="input-line">
                    <div class="input-title">
                        <p>Nome da Empresa*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.fiador_1.nome_empresa" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.fiador_1.data_entrada)} && !pensionistaOuOutro(stepdata.fiador_1)" class="input-line">
                    <div class="input-title">
                        <p>Data de Entrada na Empresa</p>
                    </div>

                    <div class="input-field">
                        <input v-mask="'##/##/####'" @blur="stepdata.fiador_1.data_entrada = fixData(stepdata.fiador_1.data_entrada)" v-model="stepdata.fiador_1.data_entrada" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

            </div>

            <div v-if="numFiadores == 2">

                <div class="sectiontitle" >
                    <hr><h3> Dados 2º fiador</h3><hr>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.fiador_2.actividade_profissional)}" class="input-line cursor-pointer" @click="ddopen !== 'actividade_profissional_fiador_2' ? ddopen = 'actividade_profissional_fiador_2': ddopen = null">
                        <div class="input-title">
                            <p>Actividade Profissional*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.fiador_2.actividade_profissional" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'actividade_profissional_fiador_2', 'unflip': ddopen !== 'actividade_profissional_fiador_2'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'actividade_profissional_fiador_2'" class="input-expanded">
                            <p v-for="i in actividades_profissionais" class="expanded-line" @click="stepdata.fiador_2.actividade_profissional = i; ddopen = null;">{{i}}</p>
                        </div>
                    </transition>
                </div>

                <div :class="{'badinput': bad(stepdata.fiador_2.profissao)}" class="input-line">
                    <div class="input-title">
                        <p>Profissão*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.fiador_2.profissao" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.fiador_2.tipo_contrato)}" class="input-line cursor-pointer" @click="ddopen !== 'tipo_contrato_fiador_2' ? ddopen = 'tipo_contrato_fiador_2': ddopen = null">
                        <div class="input-title">
                            <p>Tipo de Contrato*</p>
                        </div>

                        <div class="input-field">
                            <p v-html="stepdata.fiador_2.tipo_contrato" ></p>
                        </div>

                        <div  class="input-icon">
                            <img :class="{'flip': ddopen === 'tipo_contrato_fiador_2', 'unflip': ddopen !== 'tipo_contrato_fiador_2'}" src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        </div>
                    </div>
                    <transition name="slide-fade">
                        <div v-if="ddopen === 'tipo_contrato_fiador_2'" class="input-expanded">
                            <p v-for="i in tipos_contrato" class="expanded-line" @click="stepdata.fiador_2.tipo_contrato = i; ddopen = null;">{{i}}</p>
                        </div>
                    </transition>
                </div>

                <div>
                    <div :class="{'badinput': bad(stepdata.fiador_2.antiguidade)}" class="input-line">
                        <div class="input-title">
                            <p>Antiguidade no sector (anos)*</p>
                        </div>

                        <div class="input-field">
                            <input  v-mask="'##'" v-model="stepdata.fiador_2.antiguidade" type="text">
                        </div>

                        <div class="input-icon">
                        </div>

                    </div>

                </div>

                <div :class="{'badinput': bad(stepdata.fiador_2.vencimento_mensal)}" class="input-line">
                    <div class="input-title">
                        <p>Vencimento Mensal Líquido*</p>
                    </div>

                    <div class="input-field">
                        <money v-model="stepdata.fiador_2.vencimento_mensal" v-bind="money"></money>
                    </div>

                    <div class="input-icon">
                        €
                    </div>
                </div>

                <div class="input-line">
                    <div class="input-title">
                        <p>Outros Rendimentos Mensais</p>
                    </div>

                    <div class="input-field">
                        <money v-model="stepdata.fiador_2.outros_rendimentos" v-bind="money"></money>
                    </div>

                    <div class="input-icon">
                        €
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.fiador_2.nome_empresa)} && !pensionistaOuOutro(stepdata.fiador_2)" class="input-line">
                    <div class="input-title">
                        <p>Nome da Empresa*</p>
                    </div>

                    <div class="input-field">
                        <input v-model="stepdata.fiador_2.nome_empresa" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

                <div :class="{'badinput': bad(stepdata.fiador_2.data_entrada)} && !pensionistaOuOutro(stepdata.fiador_2)" class="input-line">
                    <div class="input-title">
                        <p>Data de Entrada na Empresa</p>
                    </div>

                    <div class="input-field">
                        <input v-mask="'##/##/####'" @blur="stepdata.fiador_2.data_entrada = fixData(stepdata.fiador_2.data_entrada)"  v-model="stepdata.fiador_2.data_entrada" type="text">
                    </div>

                    <div class="input-icon">
                        <!--
                                            <img src="/static/images/pedido-ch/down-arrow-in-small-circle.svg" alt="">
                        -->
                    </div>
                </div>

            </div>


        </div>

    </div>

</template>
<script>
import { Money } from "v-money";
import { mask } from "vue-the-mask";
export default {
  components: {
    Money
  },

  directives: {
    mask
  },

  props: ["stepdata", "steps", "submitted"],

  data() {
    return {
      numFiadores: 0,
      numProponentes: 1,

      actividades_profissionais: [
        "Por conta de Outrém",
        "Por conta Própria",
        "Pensionista",
        "Outra"
      ],
      tipos_contrato: [
        "Funcionário Público",
        "Contratado a Termo Certo",
        "Efectivo",
        "Outro"
      ],

      ddopen: null,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false
      }
    };
  },

  created() {
    this.numFiadores = parseInt(this.steps[1].fiador) || 0;
    this.numProponentes = this.steps[1].proponente;
  },

  computed: {
    missingField() {
      let p1 =
        !this.stepdata.proponente_1.actividade_profissional ||
        !this.stepdata.proponente_1.profissao ||
        !this.stepdata.proponente_1.tipo_contrato ||
        !this.stepdata.proponente_1.antiguidade ||
        !this.stepdata.proponente_1.vencimento_mensal ||
        (!this.stepdata.proponente_1.nome_empresa &&
          !this.pensionistaOuOutro(this.stepdata.proponente_1)) ||
        (!this.stepdata.proponente_1.data_entrada &&
          !this.pensionistaOuOutro(this.stepdata.proponente_1));

      let p2 =
        this.numProponentes === 2 &&
        (!this.stepdata.proponente_2.actividade_profissional ||
          !this.stepdata.proponente_2.profissao ||
          !this.stepdata.proponente_2.tipo_contrato ||
          !this.stepdata.proponente_2.antiguidade ||
          !this.stepdata.proponente_2.vencimento_mensal ||
          (!this.stepdata.proponente_2.nome_empresa &&
            !this.pensionistaOuOutro(this.stepdata.proponente_2)) ||
          (!this.stepdata.proponente_2.data_entrada &&
            !this.pensionistaOuOutro(this.stepdata.proponente_2)));

      let f1 =
        this.numFiadores >= 1 &&
        (!this.stepdata.fiador_1.actividade_profissional ||
          !this.stepdata.fiador_1.profissao ||
          !this.stepdata.fiador_1.tipo_contrato ||
          !this.stepdata.fiador_1.antiguidade ||
          !this.stepdata.fiador_1.vencimento_mensal ||
          (!this.stepdata.fiador_1.nome_empresa &&
            !this.pensionistaOuOutro(this.stepdata.fiador_1)) ||
          (!this.stepdata.fiador_1.data_entrada &&
            !this.pensionistaOuOutro(this.stepdata.fiador_1)));

      let f2 =
        this.numFiadores === 2 &&
        (!this.stepdata.fiador_2.actividade_profissional ||
          !this.stepdata.fiador_2.profissao ||
          !this.stepdata.fiador_2.tipo_contrato ||
          !this.stepdata.fiador_2.antiguidade ||
          !this.stepdata.fiador_2.vencimento_mensal ||
          (!this.stepdata.fiador_2.nome_empresa &&
            !this.pensionistaOuOutro(this.stepdata.fiador_2)) ||
          (!this.stepdata.fiador_2.data_entrada &&
            !this.pensionistaOuOutro(this.stepdata.fiador_2)));

      console.log("conditions", p1, p2, f1, f2);

      return p1 || p2 || f1 || f2;
    }
  },

  methods: {
    pensionistaOuOutro(o) {
      return (
        o.actividade_profissional === "Pensionista" ||
        o.actividade_profissional === "Pensionista"
      );
    },

    bad(val) {
      return this.submitted && !val;
    },

    fixData(val) {
    	if (val) {
		    let a = val.split("/");
		    let e = a[1] + "/" + a[0] + "/" + a[2];
		    if ([4, 6, 9, 11].indexOf(parseInt(a[1])) !== -1) {
			    if (parseInt(a[0]) > 30) {
				    return "00/00/0000";
			    }
		    }
		    if (parseInt(a[1]) === 2) {
			    if (
				    parseInt(a[2]) % 400 === 0 ||
				    (parseInt(a[2]) % 4 === 0 && parseInt(a[2]) % 100 !== 0)
			    ) {
				    if (parseInt(a[0]) > 29) {
					    return "00/00/0000";
				    }
			    } else {
				    if (parseInt(a[0]) > 28) {
					    return "00/00/0000";
				    }
			    }
		    }
		    let p = Date.parse(e);
		    if (isNaN(p) === false) {
			    return val;
		    }
		    return "00/00/0000";
        }

    }
  }
};
</script>
<style lang="scss" scoped>
.badinput {
  border: solid 1px #e90054 !important;
}

.sectiontitle {
  display: flex;
  justify-content: center;
  margin-left: 0.75rem;
  margin-right: -0.75rem;
  margin-top: 5rem;
}

#stepcontent {
  position: relative;
  text-align: center;
}
#title {
  padding: 2rem 0;
}
#title h2 {
  color: #2d3256;
  font-weight: 900;
  font-size: 2.5rem;
}
#title p {
  color: #4f4f4f;
  font-weight: 400;
  font-size: 1.25rem;
}

$input-width: 45rem;

#formblock {
  max-width: $input-width;
  margin: auto;
  margin-bottom: 2rem;
}

#formblock h3 {
  font-size: 2rem;
  white-space: nowrap;
  margin: 0 0.5rem;
}

hr {
  height: 2px;
  width: 100%;
  color: #4a4a4a;
  background: #4a4a4a;
}

$font-size: 1.125rem;
$input-line-height: 3rem;
.input-line {
  border: solid 1px #f5f5f5;
  position: relative;
  background-color: #ffffff;
  width: 100%;
  height: $input-line-height;
  display: flex;
  margin: 0.75rem;
}

.input-expanded {
  position: absolute;
  background-color: #ffffff;
  width: 100%;
  margin: -0.75rem 0.75rem 0.75rem;
  color: black;
  padding: 0.5rem 1rem 0;
  max-width: $input-width;
  z-index: 4;
  max-height: $input-line-height * 0.8 * 5;
  overflow-y: auto;
}

.expanded-line {
  position: relative;
  height: $input-line-height * 0.8;
  line-height: $input-line-height * 0.8;
  font-size: $font-size * 0.8;
  display: flex;
  padding-left: 0.75rem;
  border-bottom: solid 1px #f1f1f1;
  cursor: pointer;
}

.expanded-line:hover {
  color: white !important;
  background-color: #e90054 !important;
}

.expanded-line:last-child {
  border-bottom: none;
}

.input-title {
  line-height: $input-line-height;
  padding: 0 0 0 1.25rem;
  color: black;
  font-size: $font-size;
  flex-grow: 1;
  white-space: nowrap;
}

.input-line p {
  text-align: left;
}

.input-title {
  line-height: $input-line-height;
  padding: 0 1.25rem;
  color: black;
  font-size: $font-size;
  flex-grow: 1;
  white-space: nowrap;
}

.input-field {
  //line-height:$input-line-height;
  padding: 0.675rem 1rem;
  color: black;
  font-size: $font-size;
  flex-grow: 10;
}

.input-field input {
  //line-height:$input-line-height;
  text-align: right;
  color: #4a4a4a;
  cursor: text;
  width: 100%;
  font-weight: 600;
  outline: none !important;
}

.input-field p {
  //line-height:$input-line-height;
  text-align: right;
  color: #4a4a4a;
  cursor: pointer;
  width: 100%;
  font-weight: 600;
  outline: none !important;
}

.input-icon {
  line-height: 1rem;
  padding: 1rem 0.5rem;
  color: black;
  width: 2rem;
  min-width: 22px;
}

.input-icon img {
  cursor: pointer;
}

.flip {
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  transform: rotate(180deg);
}

.unflip {
  -webkit-transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  transition: all 0.5s ease;
  transform: rotate(0deg);
}
</style>



// WEBPACK FOOTER //
// src/pages/CreditoHabitacao/Step3.vue